/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../index.css";

const Pricing = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section className="section shadow-sm lazyloaded" id="pricing">
      <span className="section-link"></span>
      <h2 className="head text-capitalize text-center">{project} - Pricing</h2>
      <div className="pricing-div text-center">
        <div className="price-card ">
          <h3 style={{ fontSize: "1.5rem", marginBlock: "1rem" }}>1 BHK</h3>
          <h4>322 Sq. ft.</h4>
          <button
            class="btn btn-sm btn-info effetGradient effectScale enqModal"
            onClick={handleShowModal}
          >
            Price Breakup
          </button>
        </div>
        <div className="price-card ">
          <h3 style={{ fontSize: "1.5rem", marginBlock: "1rem" }}>2 BHK</h3>
          <h4>550 - 768 Sq. ft.</h4>
          <button
            class="btn btn-sm btn-info effetGradient effectScale enqModal"
            onClick={handleShowModal}
          >
            Price Breakup
          </button>
        </div>
      </div>
      {/* <small
        className="d-block text-center"
        style={{ cursor: "pointer" }}
        onClick={handleShowModal}
      >
        Pre-launch pricing available for a limited time - Enquire now!
      </small> */}
    </section>
  );
};

export default Pricing;
